(function () {
  var selector = '[data-oto-tech-video]';
  var observed = new WeakSet();
  var observer = null;

  function playVideo(video) {
    video.muted = true;
    video.playsInline = true;

    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    video.pause();
  }

  function getObserver() {
    if (observer) return observer;

    if (!('IntersectionObserver' in window)) {
      return null;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { threshold: 0.35 }
    );

    return observer;
  }

  function initVideos(root) {
    var scope = root || document;
    var videos = scope.querySelectorAll(selector);
    var io = getObserver();

    videos.forEach(function (video) {
      if (observed.has(video)) return;

      observed.add(video);
      video.muted = true;
      video.playsInline = true;

      if (io) {
        io.observe(video);
      } else {
        playVideo(video);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideos(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVideos(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(selector).forEach(function (video) {
      pauseVideo(video);
    });
  });
})();
